import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingStateProps {
  text?: string;
  className?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ 
  text = 'Loading...', 
  className = '' 
}) => {
  return (
    <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
      <Loader2 className="h-8 w-8 animate-spin text-brand-light mb-2" />
      <p className="text-sm text-muted-foreground">{text}</p>
    </div>
  );
}; 